export default {"src":"/login-app/[GIT_HASH]/_next/static/media/github_pr_closed.d7f359d9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};